import { Component, HostListener, OnDestroy, OnInit } from "@angular/core";
import { FormBuilder, FormGroup, ValidationErrors, Validators } from "@angular/forms";
import { Store } from "@ngrx/store";
import { DynamicDialogConfig, DynamicDialogRef } from "primeng/dynamicdialog";
import { Observable, Subscription, filter } from "rxjs";
import { AppState } from "src/app/store/app.reducer";
import * as DeviceVctActions from 'src/app/store/device-vct/device-vct.actions';
import { StandardPageLayout, StandardNewValidator } from "src/app/modules/shared/stdlayoutlib/classes.stdlayoutlib";
import { selectDeviceVctModuleEdited, selectDeviceVctModuleEditing } from "src/app/store/device-vct/device-vct.selector";
import { FeatureVct, ModuleVct } from "src/app/model/device-vct/device-vct-implant";
import { DevicesVctFeatures } from "src/app/conf/devices-vct";

@Component({
	templateUrl: './edit-unit-vct.dialog.component.html',
})

export class EditUnitVctDialogComponent implements OnInit, OnDestroy {
	editDeviceForm: FormGroup;

	module: ModuleVct;

	deviceVctModuleEditing$: Observable<boolean | undefined>;
	deviceVctModuleEdited$: Observable<boolean | undefined>;
	deviceVctModuleEditedSub: Subscription;

	featureListShow: FeatureVct[];

	screenWidth: number;

	constructor(
		private store: Store<AppState>,
		private dialogRef: DynamicDialogRef,
		public config: DynamicDialogConfig,
		private formBuilder: FormBuilder,
	) {
		if (config.data !== undefined && this.config.data.module !== undefined) {
			this.module = this.config.data.module;
		} else {
			this.module = undefined;
		}
		this.initSelectors();
	}

	initSelectors(): void {
		this.deviceVctModuleEditing$ = this.store.select(selectDeviceVctModuleEditing);
		this.deviceVctModuleEdited$ = this.store.select(selectDeviceVctModuleEdited);
	}

	ngOnInit(): void {
		this.featureListShow = [];
		this.subscribeAll();
		if (this.module !== undefined) {
			this.buildForm();
		}
		this.onResize();

		StandardNewValidator.setFirstCompile(true);
	}

	ngOnDestroy(): void {
		this.deviceVctModuleEditedSub?.unsubscribe();
	}

	buildForm(): void {
		this.editDeviceForm = this.formBuilder.group(this.buildFormBuilder());
	}


	buildFormBuilder() {
		this.featureListShow = [];
		const res = {};
		let name = this.module.Name;
		if (this.module.AliasName !== '') {
			name = this.module.AliasName;
		}
		res['name'] = [name, [Validators.required,]];
		if (this.module.Features !== undefined && this.module.Features.length > 0) {
			this.module.Features.forEach((fea) => {
				if (fea.FeatureId === DevicesVctFeatures.InternalDevice) {
					let name = fea.Name;
					if (fea.AliasName !== '') {
						name = fea.AliasName;
					}
					res[fea.Id] = [name, [Validators.required]];
					this.featureListShow.push(fea);

				}
			});
		}
		return res;
	}

	subscribeAll(): void {
		this.deviceVctModuleEditedSub = this.deviceVctModuleEdited$
			.pipe(filter(result => !!result))
			.subscribe(() => this.dialogRef.close('success')
			);
	}

	get f(): any {
		return this.editDeviceForm.controls;
	}

	closeDialog(): void {
		this.dialogRef.close();
	}

	getFormValidationErrors(): boolean {
		let atLeastOneError = false;
		Object.keys(this.editDeviceForm.controls).forEach(key => {
			const controlErrors: ValidationErrors = this.editDeviceForm.get(key).errors;
			if (controlErrors != null) {
				/* Object.keys(controlErrors).forEach(keyError => {
					console.log('Key control: ' + key + ', keyError: ' + keyError + ', err value: ', controlErrors[keyError]);
				}); */
				atLeastOneError = true;
			}
		});
		return atLeastOneError;
	}

	submit(): void {
		StandardNewValidator.setFirstCompile(false);
		if (!this.getFormValidationErrors()) {
			this.save();
		}
	}

	save(): void {
		let edit = false;
		let newName = this.f.name.value;
		if (this.module.AliasName !== newName) {
			this.store.dispatch(DeviceVctActions.editVctModuleName({ moduleId: this.module.Id, aliasName: newName }));
			edit = true;
		}
		if (this.module.Features !== undefined && this.module.Features.length > 0) {
			this.module.Features.forEach((fea) => {
				if (fea.FeatureId === DevicesVctFeatures.InternalDevice) {
					newName = this.f[fea.Id].value;
					if (fea.AliasName !== newName) {
						this.store.dispatch(DeviceVctActions.editVctFeatureName({ featureId: fea.Id, aliasName: newName }));
						edit = true;
					}
				}
			});
		}
		if (!edit) {
			this.closeDialog();
		}
	}

	// Design
	@HostListener('window:resize')
	onResize() {
		this.screenWidth = window.innerWidth;
	}

	onExtendedMobile(): boolean {
		return StandardPageLayout.onExtendedMobile(this.screenWidth);
	}

	justifyContentStyle(): string {
		return StandardNewValidator.justifyMessagesNewValidator(this.screenWidth);
	}

	dynamicButtonWidth(): string {
		return StandardPageLayout.dynamicButtonWidth(this.screenWidth);
	}

	dynamicInputTextWidth(): string {
		return StandardPageLayout.dynamicInputTextWidth(this.screenWidth, 'w-30rem');
	}

	newShowErrors(type: EditUnitVctDialogComponent['f'], classType: string): string {
		return StandardNewValidator.newShowErrors(type, classType, this.screenWidth);
	}

	showErrorRequiredMessage(type: EditUnitVctDialogComponent['f']): boolean {
		return StandardNewValidator.showErrorRequiredMessage(type);
	}

	customPaddingX(): string {
		return StandardPageLayout.customPaddingX(this.screenWidth);
	}

}